import gql from 'graphql-tag';
import announcementFragment from './announcement-fragment';

export default gql`
  mutation markAnnouncementViewed($input: markAnnouncementViewedInput!) {
    markAnnouncementViewed(input: $input) {
      viewer {
        id
        publishedAnnouncement {
          id
          ...AnnouncementDetails
        }
      }
    }
  }
  ${announcementFragment}
`;
